var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customcheckerboard-almost-done"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "colums small-8 medium-6 small-centered"
  }, [_c('h3', {
    staticClass: "customcheckerboard-almost-done-title"
  }, [_vm._v(_vm._s(_vm.translations.customCheckerboardAlmostDoneTitle))])]), _c('div', {
    staticClass: "colums small-8 medium-7 small-centered"
  }, [_c('p', {
    staticClass: "customcheckerboard-almost-done-text"
  }, [_vm._v(_vm._s(_vm.subtitleText))])]), _c('create-new-checkerboard'), _c('continue-same-checkerboard'), _c('div', {
    staticClass: "customcheckerboard-almost-done-linebreak text-center"
  }, [_c('span', {
    staticClass: "customcheckerboard-almost-done-linebreak-line"
  }), _c('span', {
    staticClass: "customcheckerboard-almost-done-linebreak-text"
  }, [_vm._v(_vm._s(_vm.translations.ugcInterModalOR))])]), _c('div', {
    staticClass: "customcheckerboard-almost-done-wrapper colums small-8 medium-7 small-centered"
  }, [_c('p', {
    staticClass: "customcheckerboard-almost-done-text"
  }, [_vm._v(_vm._s(_vm.translations.customCheckerboardAlmostDoneDescr))])]), _c('finish-almost-done')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }